import type { QueryClient } from '@tanstack/react-query';

import type { PracticeAccessSource } from '@nesso/practice-contracts/practice-access-rule.access-sources';

import { practiceMemberOptions } from '../api/practice-member.queries';
import { getMissingAccessSources } from './get-missing-access-sources';

export async function hasPermission(
    queryClient: QueryClient,
    requiredAccessSources: PracticeAccessSource[],
): Promise<boolean> {
    const data = await queryClient.ensureQueryData(practiceMemberOptions());
    return getMissingAccessSources(data.accessSources, requiredAccessSources).length === 0;
}
